// removed by extract-text-webpack-plugin
module.exports = {"CheckYourEmailDiv":"TJd4lb27nmqE0oTQS_aCs","Hint":"_3mp7kWMQ-mMRujNT8hCVsT"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ForgotPassword/index.css
// module id = 817
// module chunks = 0